export function getImagePath(path?: string) {
  return path ? `${import.meta.env.VITE_PUBLIC_RESOURCE_PATH}/${path}` : ""
}
